import { render, staticRenderFns } from "./info-legal.vue?vue&type=template&id=43516c5c&scoped=true"
import script from "./info-legal.vue?vue&type=script&lang=js"
export * from "./info-legal.vue?vue&type=script&lang=js"
import style0 from "./info-legal.vue?vue&type=style&index=0&id=43516c5c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43516c5c",
  null
  
)

export default component.exports